module.exports = {
  common: {
    all: "All",
    searchPlaceholder: "Searching in Cold Storage",
    recentlySearched: "Search history",
    hotKeywords: "Hot Keywords",
    clearAll: "Clear All",
    language: "language",
    register: "Sign up",
    login: "Log in",
    home: "Home",
    searchResult: "Search Result",
    wellcome: "Cold Storage",
    aboutWellcome: "About Cold Storage",
    filter: " filter",
    sortBy: "Sort By",
    recommended: "Recommended",
    topSales: "Top Sales",
    price: "Price",
    brand: "Brand",
    showResult: "Show result",
    show: "Show",
    result: "result",
    results: "results",
    lowestFirst: "Lowest First",
    highestFirst: "Highest First",
    addToCart: "Add to Cart",
    previous: "Previous",
    next: "Next",
    goToPage: "Go to Page",
    go: "Go",
    soldOut: "Sold Out",
    showMore: "Show More",
    showLess: "Show Less",
    allCategories: "All Categories",
    account: "My Account",
    addresses: "Addresses",
    myCards: "My Cards",
    myCoupons: "My Coupons",
    myOrders: "My Orders",
    accountSetting: "Account Setting",
    myProfile: "My Profile",
    logout: "Logout",
    point: "Points",
    worth: "Worth",
    confirm: "Confirm",
    cancle: "Cancle",
    logOutTips: "Logout Reminder",
    logOutMsg: "Are you sure you want to logout? ",
    logoutSuccess: "Logout successfully",
    freeDeliveryAbove: "Get free delivery above <span class='free'>{amount}</span>",
    freeDeliveryMore: "<span class='free'>{amount}</span> more to get free delivery",
    freeDeliveryGet: "Great! You get free delivery!",
    viewAll: "View All",
    findSimilar: "Find Similar",
    similarProducts: "Similar Products",
    loginAndregister: "Sign up | Log in",
    signUpSuccess: "Sign up successfully",
    loginInSuccess: "Log in successfully",
    selectDeliveryAddress: "select Delivery Address",
    orderList: "My Orders",
    collectOrderNotice: "Add more item(s) below to cart and enjoy the offer",
    orderDetails: "Order Details",
    searchResults: "{searchResult} results",
    multipleOffers: "Multiple offers",
    loginExpired: "Login is expired, please login again if you want to continue your operation",
    checkYourAddress: "Check your address before shopping",
    checkYourAddressTips:
      " Your delivery address will affect product availability. To ensure a smooth checkout process, please check that this is the address you're shopping for. Click address above to change.",
    ok: "ok",
    deliverTo: "Deliver to",
    noAdress: "No saved address found",
    addAddress: "Add address",
    addDeliveryAddress: "Add delivery address",
    default: "Default",
    similarLikeTitle: "Similar products you might like:",
    categories: "Categories",
    noAddressPopTitle: "Where should we deliver to?",
    noAddressPopContent: "Please provide your delivery address so we can offer you the best shopping experience",
    backToBrowse: "Back to browse",
    addNewAdd: "Add Address",
    unavaliableDeliveryAddressTips:
      "Sorry,we are currently unavaliable to provide our services to your delivery address,",
    changeDeliveryAddressTips: "please try to change your delivery address or wait for our further update.",
    thankYouTips: "Thank you for your support!",
    yes: "YES",
    no: "NO",
    logoutfailed: "Logout failed",
    customer: "Customer Care",
    wellCenter: "Cold Storage Shop help center",
    storeLocator: "Store Locator",
    ourStory: "Our Story",
    contactUs: "Contact us",
    careers: "Careers",
    termsAndConditions: "Terms and conditions",
    feedback: "Give Feedback",
    updatePassword: "Change Password",
    notification: "Notification",
    shareWithCopyText: "Copied to clipboard,you're ready to share this product with friends.",
    shareWithFriends: "Share with friends"
  },
  category: {
    result: "results",
    category: "Category",
    name: "Categories",
    noResult: "We cannot find any items match your filter criteria, please modify and try again.",
    search: "Search ",
    noResults: "No Results",
    all: "All"
  },
  search: {
    noResultTip:
      "Sorry, we can't find <span class='highlight'>\"{keyword}\"</span> product(s). We recommended relevant items for you:",
    resultTip: "{count} items found for <span class='highlight'>\"{keyword}\"</span>"
  },
  footer: {
    download: "Great deals at your fingertips. Download now!",
    aboutWellcome: "About Cold Storage",
    aboutMarketplace: "About Market Place",
    faq: "FAQs",
    contact: "Contact Us",
    email: "Email",
    payment: "Payment Methods",
    terms: "Terms & Conditions",
    privacy: "Privacy Policy",
    dfi: "DFI Retail Group",
    storeLocator: "Store Locator",
    ourStory: "Our Story",
    careers: "Careers",
    officeHours: "Office Hours",
    officeHoursValue: "Monday – Sunday, 9:00 AM – 9:00 PM (including Public Holidays)",
    wellcomeWhatsAppTermsAndConditions: "Cold Storage WhatsApp Terms and Conditions",
    productRecall: "Product Recall",
    productRecallLink: "https://coldstorage.com.sg/d/iA1V4lBNfRYHjac.html",
    emailBulkorderLink: "bulkorder@coldstorage.com.sg",
    b2bBulkOrdersEnquires: "B2B & Bulk Orders Enquiries"
  },
  cms: {
    addToCart: "Add to Cart",
    findSimilar: "Find Similar",
    soldOut: "Sold Out",
    viewAll: "View All"
  },
  productDetails: {
    productDetails: "Product Details",
    youMightAlsoLike: "You might also like",
    freshnessTitle: "Freshness Information",
    freshnessInfo: "Cold Storage promises this item will stay fresh for {num} days, including the day of delivery.",
    size: "Size",
    storage: "Storage",
    freshness: "Freshness",
    country: "Country",
    offers: "Offers",
    description: "Description",
    redemption: "Redemption",
    gift: "Gift"
  },
  paymentSuccessful: {
    tips: "Payment status is delayed by about 3-5 minutes. If you have any questions, please contact customer service.",
    paymentSuccessful: "Payment Successful!",
    expectedDeliveryDateAndTime: "Expected Delivery Date and Time:",
    expectedPickupDateAndTime: "Expected Pick up Date and Time:",
    continueShopping: "Continue Shopping",
    viewOrder: "View Order",
    pickUpDate: "Pick up in {date} days"
  },
  pendingPayment: {
    pendingPayment: "Pending Payment",
    tips: "Payment will be processed in Singapore Dollars (S$)",
    with: " with enJoy Card",
    saved: "Saved",
    payFail: "Payment Error Detected"
  },
  order: {
    hideDetails: "Hide Details",
    showDetails: "Show Details",
    lastThreeMonths: "Orders of last 3 months",
    threeMonthsAgo: "Orders of 3 months ago",
    ordersFromWebsite: "Orders from Website",
    pleaseSelect: "Please select",
    goToAppTips: "Please go to our Cold Storage app and check more details",
    total: "Total",
    pieces: "pieces",
    orderPlaced: "Order placed:",
    parentOrderNo: "Parent Order No:",
    orderNo: "Order No:",
    noAppOrder: " No order record is located",
    noWebOrder: " No order record is located",
    startShopping: "Start Shopping",
    my: "My",
    order: "Online Shop Order",
    banner:
      "All orders are synced from the Cold Storage app. Some orders might be split, but we will deliver them together for each purchase.",
    syncedOrder: "Current order is synced from Cold Storage app.",
    gift: "Gift",
    redeemed: "Redeemed"
  },
  orderDetails: {
    orderNo: "Order number:",
    checkSignature: "Check signature",
    eReceipt: "E-receipt",
    deleteOrder: "Delete Order",
    deleteOrderTips: "Are you sure you want to delete the order?",
    cancel: "Cancel",
    buyAgain: "Buy Again",
    stayHere: "Stay here",
    goToCart: "Go to cart",
    copySuccess: "Copy successfully",
    deleteOrderSuccess: "Order is deleted",
    cancelOrderSuccess: "Order is cancelled",
    reason: "Please select a Reason",
    totalItems: "Total {totalCount} Item(s)",
    freeGifts: "Free gifts",
    free: "Free",
    checkout: "Checkout",
    orderSummary: "Order summary",
    saved: "Saved",
    total: "Total",
    relatedOrderNo: "Related Order No:",
    cancelReason: "Cancel Reason",
    reasonPlaceholder: "Please select a reason",
    confirm: "Confirm",
    cancelOrder: "Cancel Order",
    cancelAll: "Cancel All",
    quantity: "QTY",
    productdisabledTitle: "View item details with Cold Storage app",
    outOfStock: "Out of stock",
    ordersFromDifferentStores:
      "This order contains multiple orders from different stores, please click 'Confirm' to cancel the entire order.",
    confirmO: "Confirm",
    pendingPaymentTips:
      "This order contains multiple orders from different stores, please click continue to proceed the checkout.",
    confirmP: "Continue",
    contactOurDeliveryMan: "Contact our delivery staff"
  },
  dshop: {
    activityNotStarted: "This promotion event has not started yet, please come again later({code})",
    activityOver: "This promotion event has ended, thank you for your support({code})",
    activityRegionNotMatch:
      "Sorry, this promotion event is not supporting your delivery address, thank you for your support({code})",
    activitySorryWrong: "Sorry, the network is unstable, please retry({code})",
    retry: "Retry",
    goToHomepage: "Go to homepage",
    allCategories: "All {num} categories"
  },
  cart: {
    my: "My",
    myCart: "My Cart",
    selectAll: "Select All",
    remove: "Remove",
    addMore: "Add more",
    deliverTo: "Deliver to",
    change: "Change",
    edit: "Edit",
    coupons: "Coupons",
    applied: "applied",
    available: "available",
    total: "Total",
    totleSaved: "Saved",
    saved: "Saved",
    checkout: "Check out",
    removeTitle: "Remove from the cart",
    removeMessage: "Are you sure you want to remove these item(s) ?",
    cancel: "Cancel",
    addressChangedTips: "Your basket has been updated to reflect available items",
    stockTips: "Only {stock} unit(s) left",
    maximumStockTips: "The quantity of selected item has reached the maximum stock",
    rangeNotNearestTitle: "The following items cannot be delivered to your address",
    rangeStandardDeliveryTitle:
      "The following items cannot be delivered to you, please enjoy the full shopping experience in our Cold Storage app",
    unRangeStoreGroupTitle:
      "The following items cannot be delivered to you with express delivery in the website yet, please enjoy the full shopping experience in our Cold Storage app",
    deliveryAndPackagingFee: "Including delivery fee ${deliveryFee} + packaging handling fee ${packagingFee}",
    onlyDeliveryFee: "Including delivery fee ${deliveryFee}",
    onlyPackagingFee: "Including packaging handling fee ${packagingFee}",
    handlingAndPackagingFee:
      "Including Click & Collect Handling Fee ${handlingFee} + packaging handling fee ${packagingFee}",
    onlyHandlingFee: "Including Click & Collect Handling Fee ${handlingFee}",
    saveMoreOffersTitle: "Save more with our offers",
    viewMore: "View more",
    viewLess: "View less",
    emptyText: "Your Cart is Empty",
    continueShopping: "Continue Shopping",
    freeGifts: "Free gifts",
    soldout: "Sold out",
    free: "Free",
    unavailableWaresTitle: "{count} item(s) in your cart are not available",
    findSimilar: "Find similar",
    editRecipient: "Edit Recipient",
    mandatoryFields: "* mandatory field(s)",
    recipientName: "Recipient Name*",
    recipientMobileNumber: "Recipient Mobile Number*",
    recipientWarningTextWith8to10Digits: "Please enter the 8-10 digit phone number starting with 0/1",
    recipientWarningTextWith8Digits: "Please enter an 8 digit of phone number starting with 8/9",
    save: "Save",
    myAddresses: "My Addresses",
    select: "Select",
    giftSelectMsg: "Select {maxGiftQty} free gift(s)",
    changedGiftOrTradeMsg: "Your Gift(s)/Redeem Offer Updated",
    changedGiftOrTradeMinorMsg: "Your gift/redemption items have been updated due to changes in purchase quantity.",
    redeemFreeMsg: "Redeem selected items for Free",
    redeemVerticalReductionMsg: "Redeem selected items and Save ${value}",
    redeemDiscountMsg: "Redeem selected items and Get {value}% off",
    redeemSpecialOfferMsg: "Redeem selected items for ${value}",
    slaveStoreMsg:
      "Seamlessly check out items from other stores synced with your Cold Storage app on the Cold Storage website",
    slaveStoreTip: "View item details with Cold Storage app",
    RedeemNow: "Redeem now",
    GoBack: "Go Back",
    pickUpAt: "Pick up at:",
    deliveryOnlyDesc: "{count} items are available for home delivery only",
    seeItems: "See items",
    deliveryOnlyTitle: "The following items are only available for home delivery",
    reminder: "Reminder",
    giftMessage:
      "You have forgot or haven't added enough free gift item(s) to your cart, do you still want to continue checkout?",
    no: "No",
    yesContinue: "Yes, Continue",
    giftNotEnough: "Sorry, inventory is not enough",
    allGiftOutOfStock: "Sorry, all free gift(s) are out of stock",
    pleaseEnterPickupName: "Please input the pickup person's name"
  },
  coupon: {
    myCoupons: "My Coupons",
    emptyText: "You don't have any coupons yet",
    usageRules: "Usage rules",
    valid: "Valid",
    invalid: "Invalid",
    reedem: "Redeem",
    reedemMessage: "Your coupon has been successfully redeemed!",
    daysLeft: "{count} day(s) left",
    effectivePeriod: "Effective Period",
    applicableFor: "Applicable for",
    coupons: "Coupon(s)",
    apply: "Apply",
    applySuccessMessage: "Your coupon has been successfully applied!",
    applyInapplicableMessage:
      "Sorry, this coupon is not applicable to the current order.Please double check its usage conditions.",
    chosenSavedText: "You have chosen {length} coupon(s), and Saved",
    applicable: "Applicable",
    inapplicable: "Inapplicable",
    enterPlaceholder: "Enter your coupon code here",
    EGiftVoucher: "Online Shop Voucher",
    ECoupon: "E-Coupon",
    combinedText: "Can be combined with other coupon"
  },
  checkout: {
    mark1: "Please call me before delivery",
    mark2: "Please leave the goods at door",
    markAny: "Please fill other instructions here if any",
    save: "save",
    headerTitle: "Secure Checkout",
    deliverTo: "Deliver to",
    edit: "Edit",
    addDeliveryIns: "Add Delivery Instruction",
    deliveryIns: "Delivery Instruction",
    deliverTime: "Deliver Time",
    pleaseSelect: "Please Select",
    noAvailable: "No available delivery slot",
    coupons: "Coupons",
    available: "available",
    applied: "applied",
    paymentMethod: "Payment Method",
    cardTips: "We current only accept credit card (Visa and MasterCard only) payments on our website.",
    cardTips2:
      "A temporary charge of HK$0.10 may appear in your transaction history to verify that your card is open and in good standing. Upon verification, the HK$0.10 will be released.",
    promotionTips:
      "Save 8% on your purchases of $100 or more (net spending) at Cold Storage & Market Place with Hang Seng enJoy Card today.",
    addNewCard: "Add New Credit Card",
    orderReview: "Order Review",
    DSecureAuth: "3-D Secure Auth",
    add: "Add",
    change: "Change",
    select: "Select",
    next: "Next",
    payNow: "Pay & Verify",
    cardVeri: "Credit Card Verification",
    mandatoryFileds: "mandatory field(s)",
    cardNumber: "Card number",
    creditCardNumber: "Your Credit Card number",
    expiryDate: "Expiry Date (month/year)",
    mm: "MM",
    yy: "YY",
    digits: "3 digits on the back of card",
    cardholderName: "Cardholder's name",
    nameOnCard: "Your name on the card",
    saveTips: "Save credit card as default for next purchase",
    showDetails: "Show Details",
    hideDetails: "Hide Details",
    total: "Total",
    total2: "Total",
    item: "Item(s)",
    orderSummary: "Order Summary",
    infoTips: "If out of stock, deliver remaining items (out-of-stock items will be auto refunded)",
    pay: "Pay",
    saved: "Saved",
    summaryTips1: 'By clicking "Pay", I agree that the',
    summaryTips2: "will govern my purchase.",
    errorTips: "error status",
    bindCardSuccess: "bind card success",
    bindCardFail: "bind card fail",
    Including: "Including ",
    deliveryFee: "delivery fee",
    packagingHandlingFee: "packaging handling fee",
    week: ["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"],
    month: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "July", "Aug", "Sept", "Oct", "Nov", "Dec"],
    format: "en",
    freeGifts: "Free gifts",
    free: "Free",
    note: "Note",
    backToCart: "Back to Cart",
    pendingPayment: "Pending Payment",
    notice: "Notice",
    text: "For standard products ordered, you cannot cancel such order once we have commenced/confirmed packing, picking or delivery of the products to you. For any special items ordered, no cancellation is possible after payment confirmation.",
    tipsCancel: "Under 18",
    tipsConfirm: "18 or above",
    noCardTips: "Select your payment method",
    payAnyway: "Pay Anyway",
    error: {
      cardNumber: "Please use a Visa or MasterCard credit card, or check if the card number is correct",
      expiryDate: "Incorrect expiry date",
      securityCode: "CVV invalid or missing"
    },
    systemError: "You stayed on this page too long, please enter this page again.",
    homeDelivery: "Home Delivery",
    clickCollect: "Click & Collect",
    pickAt: "Pick up at:",
    noTimeTips: "Please select delivery time",
    recommended: "Recommended",
    continueWithThisSlot: "Continue with this slot",
    unableTips: "Deselecting items may change the promotions and freebies options. Delivery fee may also apply.",
    viewCart: "View in my cart",
    processCheckout: "Proceed to check out",
    unavailableItems: "Unavailable items",
    unavailableItemsWarn:
      "If you proceed with this time slot, the item mentioned below will not be included in your payment but will remain in your cart.",
    unavailableItemsText:
      "By continue with this slot you will have changes on  promotions, freebie, or redemptions item.",
    redeemed: "redeemed",
    gift: "Gift",
    full: "Full",
    deliveryFee2: "Delivery fee:"
  },
  card: {
    myCards: "My Cards",
    add: "Add New Card",
    deleteCard: "Delete Credit Card",
    confirmText: "Are you sure you want to delete this credit card from your account? ",
    cancel: "No",
    confirm: "Delete",
    message: "Successfully unbinding"
  },
  pageTitle: {
    cart: "My Cart",
    checkout: "Secure Checkout",
    cards: "My Cards",
    coupons: "My Coupons",
    order_list: "My Orders",
    order_details: "Order Details",
    cashier: "Checkout Cashier",
    payment: "Payment Successful",
    categoryName: "{name}",
    storeLocator: "Store Locator",
    login: "Sign in to ColdStorage",
    signUp: "Sign up for ColdStorage",
    passwordReset: "Forgot your password?",
    passwordUpdate: "Change your password"
  },
  getTheApp: {
    title: "Cold Storage mobile is better on the Cold Storage app ",
    description: "For an optimized mobile experience, shop in Cold Storage online shop now!",
    goTo: "Go to Cold Storage",
    notNow: "Not now"
  },
  page: {
    title: "Cold Storage online shop",
    description:
      "Shop for fresh, quality groceries from the comfort of your home with Cold Storage Online. Offering a wide range of international products and gourmet specialties, experience easy online shopping with great prices and exclusive deals every day. Free shipping for delivery over $80, visit us now!"
  },
  error: {
    pageNotFound: "Page Not Found",
    serverError: "Server Error",
    backHome: "Go to homepage",
    notFound: "404 - PAGE NOT FOUND",
    notFoundTips: "The page you are looking for might have removed",
    internalServerError: "500 - INTERNAL SERVER ERROR",
    internalServerErrorTips: "Sorry, the server is temporarily unavailable. Please try again later."
  },
  collect: {
    bestOfferTitle: "SmartSaver",
    bestOfferText1: "Offer(s) available",
    bestOfferText2: "Add more item(s) to enjoy our offer(s)"
  },
  address: {
    addNewAddress: "Add new address",
    confirm: "Confirm",
    pleaseNoteQuantityAndPromotions:
      "Please note that the quantity and promotions may vary based on your chosen delivery method.",
    edit: "Edit",
    remove: "Remove",
    default: "Default address",
    defaultAddressTips: "This will be your default address automatically",
    mandatoryFields: "Required",
    address: "Address",
    floorAndUnit: "Floor & Unit",
    buildingAndEstate: "Building & Estate",
    addressLabel: "Address Label",
    selectDeliveryAddress: "Select delivery address",
    addAddress: "Add address",
    pleaseFillYourAddressHere: "Please fill your address here",
    EgUnit606: "E.g. Room 601",
    pleaseFill: "Optional",
    enterAddressLabel: "Enter Address Label",
    editAddress: "Edit address",
    removeThisAddress: "Remove this address?",
    actionCannotUndone: "This action cannot be undone.",
    keepAddress: "Keep address",
    addressRemoved: "Address Removed",
    home: "Home",
    work: "Work",
    other: "Other",
    makeThisMyDefaultAddress: "Make this my default address",
    noData: "no Data",
    leavePageTipsTile: "Are you sure you want to leave this page?",
    leavePageTips: "If you leave this page, any changes you have made will be lost.",
    returnToSite: "Return to site",
    continueEdit: "Continue editing",
    freeAndFastDelivery: "Free & fast delivery!",
    addressAdded: "Address has been added",
    addressUpdated: "Address has been updated",
    loadingText: "Loading",
    userName: "Name",
    phone: "Phone Number",
    pleaseEnterName: "Please enter name",
    pleaseEnterPhoneNumber: "Please enter phone number"
  },
  deliveryMethod: {
    title: "Delivery method",
    homeDelivery: "Home delivery",
    clickCollect: "Click & collect",
    clickCollectTip: "Save more delivery fee!",
    deliveryOnly: "Delivery only",
    lowerDeliveryFee: "Free click & collect service upon low min. spend!",
    nonDeliveryDesc: "on orders over HK${amount}",
    selectPickupStore: "Select store for pick-up",
    region: "Region",
    district: "District",
    storeDisabledDesc: "Storage full, please try another day.",
    clickCollectNotice: "Please note that the quantity and promotions may vary based on your chosen delivery method.",
    confirm: "Confirm",
    pleaseSelect: "Please select",
    emptyText: "No data",
    stayTunedDesc: "More stores coming soon! Stay tuned!"
  },
  storeLocator: {
    fullMapView: "Full Map View",
    showListVew: "Show List View",
    title: "Store Locator",
    district: "Pick Zone(s)",
    service: "Pick Store Type(s)",
    listView: "List View",
    mapView: "Map View",
    getDirections: "Get Directions",
    enterAddressOrBuilding: "Enter address/building/zip code",
    openingHours: "Opening Hours",
    nearestStore: "Nearest Store",
    locationError: "Google Maps could not determine your precise location."
  },
  linkYuu: {
    id: "ID:",
    title: "Link yuu ID",
    enterYourYuuId: "Enter your yuu ID",
    linkNotice: "Have a yuu ID? Link your yuu account now to earn yuu points!",
    unlinkNotice: "Are you sure you want to unlink your yuu ID for this account?",
    cancel: "Cancel",
    unlink: "Unlink",
    textWith11Digits: "Please enter an 8-digit yuu ID number"
  },
  auth: {
    phoneNumber: "Phone number",
    login: "Login",
    signUp: "Sign up",
    changePwd: "Change Password",
    forgotPwd: "Forgot your password",
    smsCode: "SMS Code",
    enterPhoneNumber: "Phone number",
    enterYourPwd: "Enter your password",
    enterYourNewPwd: "Enter your password (6-16 characters)",
    password: "Password",
    setNewPassword: "Set New Password",
    submit: "Submit",
    or: "OR",
    loginWithSMS: "Login with SMS",
    loginWithPwd: "Login with password",
    loginWith: "Login With",
    register: "Register",
    noAccount: "No account?",
    SMSVerification: "SMS Verification",
    sendSMS: "Send Code",
    alreadyHaveAccount: "Already have an account?",
    loginTip1: "After verification, a Cold Storage / Market Place account ",
    loginTip2: "will be automatically created for unregistered phone numbers",
    protocal1: "(i) you have read and agreed to the",
    termsAndConditions: "Terms & Conditions",
    // PICS: "PICS",
    and: "and",
    privacyPolicy: "Privacy Policy",
    protocal2:
      'Cold Storage Singapore (1983) Pte Ltd ("CSS") (which owns and operates this Platform) would like to use your personpal data for',
    directMarketingPurposes: "Direct Marketing purposes",
    protocal3: "as stated in the above",
    checkTip: "Please tick this box to confirm your agreement to such use and transfer of your personal data.",
    comma: ",",
    period: ".",
    // login modal
    createANewAccount: "Create a new account?",
    createAccount: "Create Account",
    createAccountContent:
      "Your current phone number is not a registered account for Cold Storage. Please create account or enter another login information",
    enterSMSCode: "Please enter the verification code",
    enterYourPassword: "Please enter the password",
    enterYourNewPassword: "Please enter your new password",
    invalidPhoneNumber: "Please enter a valid phone number",
    termsAndConditionsRequired: "Please agree to the terms and conditions",
    // sign up modal
    loginWithYourAccount: "Login with your account?",
    registeredAccount:
      "This is a registered phone number. Please return to login page and enter your password or SMS code",
    // create password modal
    skip: "Skip",
    createPassword: "Create passsword for your account?",
    reconfirmPassword: "Reconfirm Password",
    repeatYourPassword: "Repeat your password",
    cancel: "Cancel",
    resetPasswordSuccess: "Password changed successfully",
    passwordRule: "Please enter an alphanumeric password with 6-16 characters"
  }
}
